export default __webpack_public_path__ + "static/media/jamie_pcr_product_j.68681cc9.svg";